export const IMAGES = {
  hero: "/hero-guitarist.png",
  fretboard: "https://images.unsplash.com/photo-1764120965995-9e408370c66c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxndWl0YXIlMjBwbGF5ZXIlMjBibHVlJTIwc3RhZ2UlMjBsaWdodHxlbnwwfHx8fDE3OTEyMTAxMDh8MA&ixlib=rb-4.1.0&q=85",
  privateLesson: "https://images.unsplash.com/photo-1758524944402-1903b38f848f?crop=entropy&cs=srgb&fm=jpg&q=85",
  onlineLesson: "https://images.unsplash.com/photo-1601266289415-e7339a97d19b?crop=entropy&cs=srgb&fm=jpg&q=85",
  workshop: "/format-workshop.jpg",
  masterclass: "https://images.unsplash.com/photo-1591365437381-2db81d59f1e0?crop=entropy&cs=srgb&fm=jpg&q=85",
  rock: "/style-rock.jpg",
  jazz: "/style-jazz.jpg",
  blues: "/style-blues.jpg",
  fusion: "/style-fusion.jpg",
};

export const FORMATS = [
  {
    id: "aula-particular",
    index: "01",
    name: "Aulas Particulares",
    tag: "Presencial · 1 a 1",
    desc: "Sessões individuais no estúdio, com repertório e técnica moldados ao seu momento. O caminho mais rápido entre onde você está e onde quer chegar.",
    image: IMAGES.privateLesson,
  },
  {
    id: "aula-online",
    index: "02",
    name: "Aulas Online",
    tag: "Ao vivo · de qualquer lugar",
    desc: "A mesma profundidade do presencial, via videochamada com áudio em alta definição, material digital e gravação da sessão.",
    image: IMAGES.onlineLesson,
  },
  {
    id: "workshop",
    index: "03",
    name: "Workshops",
    tag: "Grupo · imersões temáticas",
    desc: "Imersões de um dia sobre temas específicos: improvisação modal, fraseado de blues, técnica de mão direita e mais.",
    image: IMAGES.workshop,
  },
  {
    id: "masterclass",
    index: "04",
    name: "Masterclasses",
    tag: "Convidados · alto nível",
    desc: "Encontros com guitarristas de referência, abrindo o processo criativo, o estudo e a vida de palco de perto.",
    image: IMAGES.masterclass,
  },
];

export const FORMATS_EN = [
  {
    id: "aula-particular",
    index: "01",
    name: "Private Lessons",
    tag: "In person · 1 on 1",
    desc: "One-on-one sessions in the studio, with repertoire and technique shaped to your moment. The fastest path between where you are and where you want to be.",
    image: IMAGES.privateLesson,
  },
  {
    id: "aula-online",
    index: "02",
    name: "Online Lessons",
    tag: "Live · from anywhere",
    desc: "The same depth as in person, via video call with high-definition audio, digital material and a recording of the session.",
    image: IMAGES.onlineLesson,
  },
  {
    id: "workshop",
    index: "03",
    name: "Workshops",
    tag: "Group · themed immersions",
    desc: "One-day immersions on specific topics: modal improvisation, blues phrasing, right-hand technique and more.",
    image: IMAGES.workshop,
  },
  {
    id: "masterclass",
    index: "04",
    name: "Masterclasses",
    tag: "Guests · high level",
    desc: "Sessions with reference guitarists, opening up the creative process, the practice routine and life on stage up close.",
    image: IMAGES.masterclass,
  },
];

export const LEVELS = [
  {
    id: "iniciante",
    name: "Iniciante",
    headline: "Fundamentos que libertam",
    desc: "Do zero ao primeiro solo. Construímos base técnica e musical sem atalhos — para que o improviso nasça sobre chão firme.",
    milestones: [
      "Postura, afinação de ouvido e técnica de mão direita",
      "Acordes abertos e as primeiras progressões",
      "Pentatônica menor: o desenho que muda tudo",
      "Seu primeiro solo guiado sobre 12 compassos",
    ],
    outcome: "Você sai tocando um blues completo, com improviso próprio.",
  },
  {
    id: "intermediario",
    name: "Intermediário",
    headline: "Do desenho à linguagem",
    desc: "Você já conhece as escalas — agora é hora de fazê-las cantar. Fraseado, dinâmica e vocabulário de verdade.",
    milestones: [
      "Os 5 desenhos da pentatônica conectados no braço",
      "Bending, vibrato e articulação com identidade",
      "ii–V–I e progressões funcionais na prática",
      "Improviso com intenção sobre backing tracks",
    ],
    outcome: "Você assina solos autorais sobre blues, rock e standards.",
  },
  {
    id: "avancado",
    name: "Avançado",
    headline: "A sua voz no instrumento",
    desc: "Refinamento de altíssimo nível: harmonicamente sofisticado, tecnicamente preciso, artisticamente seu.",
    milestones: [
      "Arpejos estendidos e superimposições harmônicas",
      "Modos, escalas alteradas e playing outside",
      "Chord melody e arranjos para guitarra solo",
      "Transcrição e análise de mestres do instrumento",
    ],
    outcome: "Uma linguagem própria, pronta para palco e estúdio.",
  },
];

export const LEVELS_EN = [
  {
    id: "iniciante",
    name: "Beginner",
    headline: "Fundamentals that set you free",
    desc: "From zero to your first solo. We build a technical and musical foundation with no shortcuts — so improvisation is born on solid ground.",
    milestones: [
      "Posture, tuning by ear and right-hand technique",
      "Open chords and your first progressions",
      "Minor pentatonic: the shape that changes everything",
      "Your first guided solo over 12 bars",
    ],
    outcome: "You leave playing a full blues, with your own improvisation.",
  },
  {
    id: "intermediario",
    name: "Intermediate",
    headline: "From shapes to language",
    desc: "You already know the scales — now it's time to make them sing. Phrasing, dynamics and real vocabulary.",
    milestones: [
      "The 5 pentatonic shapes connected across the neck",
      "Bending, vibrato and articulation with identity",
      "ii–V–I and functional progressions in practice",
      "Intentional improvisation over backing tracks",
    ],
    outcome: "You sign your own solos over blues, rock and standards.",
  },
  {
    id: "avancado",
    name: "Advanced",
    headline: "Your voice on the instrument",
    desc: "Top-level refinement: harmonically sophisticated, technically precise, artistically yours.",
    milestones: [
      "Extended arpeggios and harmonic superimpositions",
      "Modes, altered scales and outside playing",
      "Chord melody and solo guitar arrangements",
      "Transcription and analysis of the instrument's masters",
    ],
    outcome: "A language of your own, ready for stage and studio.",
  },
];

export const STYLES = [
  {
    id: "rock",
    name: "Rock",
    desc: "Energia, atitude e riffs que ficam na história.",
    concepts: ["Power chords", "Palm mute", "Solos pentatônicos", "Timbre e drive"],
    image: IMAGES.rock,
  },
  {
    id: "blues",
    name: "Blues",
    desc: "A raiz de tudo. Doze compassos que cabem uma vida.",
    concepts: ["12 compassos", "Call & response", "Bending e vibrato", "Shuffle feel"],
    image: IMAGES.blues,
  },
  {
    id: "jazz",
    name: "Jazz",
    desc: "Harmonia sofisticada e a conversa em tempo real.",
    concepts: ["ii–V–I", "Chord melody", "Swing", "Arpejos estendidos"],
    image: IMAGES.jazz,
  },
  {
    id: "fusion",
    name: "Fusion",
    desc: "Fronteiras dissolvidas: técnica, groove e ousadia.",
    concepts: ["Compassos ímpares", "Modos e escalas híbridas", "Legato", "Outside playing"],
    image: IMAGES.fusion,
  },
];

export const STYLES_EN = [
  {
    id: "rock",
    name: "Rock",
    desc: "Energy, attitude and riffs that make history.",
    concepts: ["Power chords", "Palm muting", "Pentatonic solos", "Tone & drive"],
    image: IMAGES.rock,
  },
  {
    id: "blues",
    name: "Blues",
    desc: "The root of it all. Twelve bars that fit a lifetime.",
    concepts: ["12-bar blues", "Call & response", "Bending & vibrato", "Shuffle feel"],
    image: IMAGES.blues,
  },
  {
    id: "jazz",
    name: "Jazz",
    desc: "Sophisticated harmony and real-time conversation.",
    concepts: ["ii–V–I", "Chord melody", "Swing", "Extended arpeggios"],
    image: IMAGES.jazz,
  },
  {
    id: "fusion",
    name: "Fusion",
    desc: "Borders dissolved: technique, groove and daring.",
    concepts: ["Odd meters", "Modes & hybrid scales", "Legato", "Outside playing"],
    image: IMAGES.fusion,
  },
];

export const MARQUEE_TERMS = [
  "Improvisação Modal",
  "Pentatônica Menor",
  "Fraseado Bebop",
  "Bending & Vibrato",
  "Arpejos Estendidos",
  "Swing Feel",
  "Hybrid Picking",
  "Outside Playing",
  "Chord Melody",
  "Dominantes Alterados",
];

export const MARQUEE_TERMS_EN = [
  "Modal Improvisation",
  "Minor Pentatonic",
  "Bebop Phrasing",
  "Bending & Vibrato",
  "Extended Arpeggios",
  "Swing Feel",
  "Hybrid Picking",
  "Outside Playing",
  "Chord Melody",
  "Altered Dominants",
];

export const FAQ = [
  {
    q: "Preciso ter guitarra própria para começar?",
    a: "Para as aulas presenciais, não: o estúdio dispõe de instrumentos e amplificadores. Para praticar em casa, recomendamos ter o seu — e ajudamos na escolha do primeiro equipamento.",
  },
  {
    q: "Como funcionam as aulas online?",
    a: "Ao vivo, por videochamada, com configuração de áudio otimizada para instrumento. Você recebe o material da aula e a gravação da sessão para revisar quando quiser.",
  },
  {
    q: "Posso mudar de nível ou de estilo depois?",
    a: "Sempre. A avaliação de nível é contínua e o percurso é seu: muitos alunos começam no blues, atravessam o jazz e desaguam no fusion.",
  },
  {
    q: "Qual a política de cancelamento?",
    a: "Aulas podem ser remarcadas sem custo até 12 horas antes do horário agendado, direto pela Área do Aluno.",
  },
];

export const FAQ_EN = [
  {
    q: "Do I need my own guitar to start?",
    a: "Not for in-person lessons: the studio has instruments and amplifiers. To practice at home we recommend having your own — and we help you choose your first gear.",
  },
  {
    q: "How do online lessons work?",
    a: "Live, over video call, with audio optimized for the instrument. You receive the lesson material and a recording of the session to review anytime.",
  },
  {
    q: "Can I switch level or style later?",
    a: "Always. Level assessment is continuous and the path is yours: many students start with blues, cross through jazz and land in fusion.",
  },
  {
    q: "What's the cancellation policy?",
    a: "Lessons can be rescheduled free of charge up to 12 hours before the scheduled time, right from the Student Area.",
  },
];

export const ARTISTS = [
  "Felippe Valadão",
  "Mariana Valadão",
  "Ana Paula Valadão",
  "André Valadão",
  "Israel Salazar",
  "Laura Souguellis",
  "Luma Elpidio",
  "FHOPE",
];
